import React, { Suspense, useContext, useMemo } from "react";
import { SHAPE_TYPE } from "./../../ricos-content/index.js";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { Node_Type } from "./../../ricos-types/index.js";
import { getParsedShape } from "./../../_shared/shape-view-renderer/get-parsed-shape.js";
const ViewerShape = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_shape_lazy" */
    "./viewer-shape.js"
  )
);
function wrapPromise(promise) {
  let status = "pending";
  let response = null;
  const suspender = promise.then(
    (res) => {
      status = "success";
      response = res;
    },
    () => {
      status = "success";
      response = null;
    }
  );
  return {
    read() {
      if (status === "pending") {
        throw suspender;
      }
      return response;
    }
  };
}
const ShapeRenderer = ({
  shapeResource,
  ...props
}) => {
  const { node } = props;
  const shapeJson = shapeResource?.read() ?? void 0;
  return /* @__PURE__ */ React.createElement(ViewerShape, { key: node.id, ...props, shapeJson });
};
const ShapeLazy = (props) => {
  const { node } = props;
  const { config } = useContext(RicosViewerContext);
  const shapeConfig = config[SHAPE_TYPE] || {};
  const shapeSrc = node.shapeData.shape.src;
  const shapeResource = useMemo(() => {
    return wrapPromise(getParsedShape(shapeSrc, shapeConfig.getShapeUrl));
  }, [shapeSrc.id, shapeSrc.url, shapeConfig.getShapeUrl]);
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(ShapeRenderer, { ...props, shapeResource }));
};
const nodeViewRenderers = {
  [Node_Type.SHAPE]: ShapeLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
